export function assertEntityImport(
    Entity: unknown,
    name: string
): asserts Entity is new (...args: unknown[]) => unknown {
    if (typeof Entity !== 'function') {
        throw new TypeError(
            `Dynamic import of ${name} resolved as ${typeof Entity} — likely a circular dependency. ` +
                `Check that entity files and store files are in separate chunks.`
        );
    }
}
